<template>
    <transition name="modal">
        <div class="modal-mask" @click="$emit('close')">
          <div class="modal-wrapper" >
            <div class="modal-container-choice" @click.stop>
                <div class="modal-header-choice">
                    <slot name="cross">
                        <v-icon style="float: right; top: 2px;" @click="$emit('close')">mdi-close</v-icon>
                    </slot>
                    <slot name="header"> {{$t('_vous_avez_selectionne_plusieurs_points_de_mesure_pour_ce_bloc_voulez-vous_definir_une_delimitation_')}} </slot>
                </div>

                <div class="modal-footer-choice">
                    <slot name="footer">
                        <v-btn style="float: right;" @click="$emit('separate')">
                            {{$t('_oui_')}}
                        </v-btn>
                        <v-btn style="float: right; right: 5px; " @click="$emit('saveUnseparated',ptDeMesure)">
                            {{$t('_non_')}}
                        </v-btn>
                        
                    </slot>
                </div>
            </div>            
          </div>
        </div>
    </transition>
</template>

<script>

export default {
    name: "Choix",

    props: ['ptDeMesure', 'rectangleCoords']
}

</script>

<style scoped>
.modal-container-choice {
  width: 20vw;
  height: 30vh;
  margin: 0px auto;
  padding: 20px;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  border-radius: 0.25rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
}
.modal-header-choice {
  font-weight: bold;
  font-size: 1.4rem;
}
.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-default-button {
  float: right;
}
.modal-enter {
  opacity: 0;
}
.modal-leave-active {
  opacity: 0;
}
.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.modal-footer-choice {
  padding: 16px 16px;
  background-color: white;
  color: white;
  position: absolute;
  bottom: 0;
  right: 0;
}

</style>